import(/* webpackMode: "eager", webpackExports: ["Address"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/Address.js");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/Avatar.js");
;
import(/* webpackMode: "eager", webpackExports: ["Badge"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/Badge.js");
;
import(/* webpackMode: "eager", webpackExports: ["EthBalance"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/EthBalance.js");
;
import(/* webpackMode: "eager", webpackExports: ["Identity"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/Identity.js");
;
import(/* webpackMode: "eager", webpackExports: ["IdentityCard"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/IdentityCard.js");
;
import(/* webpackMode: "eager", webpackExports: ["Name"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/Name.js");
;
import(/* webpackMode: "eager", webpackExports: ["Socials"] */ "/app/node_modules/@coinbase/onchainkit/dist/identity/components/Socials.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["SecureCookiesProvider"] */ "/app/node_modules/next-client-cookies/dist/provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Unbounded\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-unbounded\",\"display\":\"swap\"}],\"variableName\":\"unbounded\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Courier_Prime\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-Courier_Prime\",\"display\":\"swap\",\"weight\":[\"400\",\"700\"]}],\"variableName\":\"courierPrime\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\",\"display\":\"swap\",\"weight\":[\"400\",\"500\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/ClientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/ToastProvider/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLocale"] */ "/app/src/app/context/ClientLocale/ClientLocale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/context/Search/CurrencyContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSearchFocus","SearchFocusProvider"] */ "/app/src/app/context/Search/SearchFocusProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSearchOfferData","SearchOfferDataProvider"] */ "/app/src/app/context/Search/SearchOfferDataContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/context/walletServiceContext/walletServiceContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
